// extracted by mini-css-extract-plugin
export default {"slider":"Slider_slider__HXBK2","last":"Slider_last__sY5CG","container":"Slider_container__Uq4xS"};